<ion-content class="login">
  <div class="login__background"></div>
  <div class="login__content">
    <app-logo class="--big --light --desktop-dark login__content__logo"></app-logo>
    <form class="login__content__form" [formGroup]="form" (keyup.enter)="doRegister()">
      <ion-item class="login__content__form__item">
        <ion-label class="label" position="stacked" [innerHTML]="'E-Mail'"></ion-label>
        <ion-input class="input" formControlName="email" placeholder="Deine E-Mail"></ion-input>
      </ion-item>

      <ion-item class="login__content__form__item">
        <ion-label class="label" position="stacked" [innerHTML]="'Passwort'"></ion-label>
        <ion-input class="input" formControlName="password" placeholder="Passwort" [type]="showPassword ? 'text' : 'password'"></ion-input>
        <ion-button class="input-button button --icon" fill="clear" (click)="toggleShowPassword()">
          <ion-icon [name]="showPassword ? 'eye-off' : 'eye'"></ion-icon>
        </ion-button>
      </ion-item>

      <ion-item class="login__content__form__item">
        <ion-label class="label" position="stacked" [innerHTML]="'Passwort wiederholen'"></ion-label>
        <ion-input
          class="input"
          formControlName="passwordRepeat"
          placeholder="Passwort wiederholen"
          [type]="showPasswordRepeat ? 'text' : 'password'"
        ></ion-input>
        <ion-button class="input-button button --icon" fill="clear" (click)="toggleShowPasswordRepeat()">
          <ion-icon [name]="showPasswordRepeat ? 'eye-off' : 'eye'"></ion-icon>
        </ion-button>
      </ion-item>

      <div class="login__content__form__buttons">
        <ion-button class="button login__content__form__buttons__button" [disabled]="form.invalid" (click)="doRegister()">
          <span *ngIf="(loading$ | async) === false" [innerHTML]="'registrieren'"></span>
          <ion-spinner *ngIf="(loading$ | async)"></ion-spinner>
        </ion-button>
        <ion-button
          class="button --text login__content__form__buttons__button"
          [innerHTML]="'Sie haben bereits ein Konto?'"
          [routerLink]="['/', routes.login]"
          [queryParams]="{ email: form.value.email }"
          [routerDirection]="'back'"
        ></ion-button>
        <ion-button
          class="button --text login__content__form__buttons__button"
          target="_blank"
          [innerHTML]="'Hilfe'"
          (click)="openHelp()"
        ></ion-button>
      </div>
    </form>
  </div>
</ion-content>
